module.exports = __webpack_public_path__ + "img/w-icon-earth.b3d78353.png";